/** Local hints only: return categories, never the matched identifying values. */
export function identifierHints(text: string): string[] {
  const checks: [string, RegExp][] = [
    ['Social Security number', /\b\d{3}-\d{2}-\d{4}\b/],
    ['date of birth', /\b(?:DOB|date\s+of\s+birth)\b\s*[:=#-]?\s*\S+/i],
    ['patient name', /\bpatient(?:\s+name)?\s*[:=]\s*\S+|\bpatient\s+name\s+\S+/i],
    ['claim or case number', /\b(?:claim|case)\s*(?:(?:number|no\.?)\s*[:=#-]?|[:=#])\s*\S+/i],
  ];
  return checks.filter(([, pattern]) => pattern.test(text)).map(([label]) => label);
}
